import type { ReactNode } from 'react'

import { cn } from '@/lib/cn'

export type InlineNoticeTone = 'danger' | 'info' | 'success' | 'warning'

const toneClassName: Record<InlineNoticeTone, string> = {
  danger: 'border-[#ffccc7] bg-[#fff1f0] text-[#b42318]',
  info: 'border-[rgba(25,91,255,0.24)] bg-[rgba(25,91,255,0.06)] text-[var(--color-primary)]',
  success: 'border-[#b7ebc6] bg-[#f0faf3] text-[#16823c]',
  warning: 'border-[#ffe0a3] bg-[#fff9ed] text-[#8a5a00]',
}

export interface InlineNoticeProps {
  children: ReactNode
  className?: string
  role?: 'alert' | 'status'
  tone?: InlineNoticeTone
}

export function InlineNotice({ children, className, role, tone = 'info' }: InlineNoticeProps) {
  return (
    <div
      className={cn(
        'rounded-lg border px-4 py-3 text-sm leading-6',
        toneClassName[tone],
        className,
      )}
      role={role}
    >
      {children}
    </div>
  )
}
